/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Ravi Ranjan Kumar, Ujjwal Singh >

*/

import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff';
// object difference
export function differenceObject(object, base) {
	// console.log('console.log(diff(lhs, rhs))',diff(object, base))
	return detailedDiff(object, base);
}


// get Name from an array using id
export function getNameFromArrayById(array,id){
       let tempArr=[]
      //  console.log("array",array)
      array.map(item=>{
        // console.log("Annotators",item.user_id)
        tempArr.push(id!==item.user_id?"":item.fname)
       })
       return tempArr
  }
//  extract date and time from date local string format 
export function getTimeDateInFormate(date){
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
// console.log("date",new Date(date).toLocaleString())
return date!==undefined? new Date(date).toLocaleDateString()+","+ new Date(date).toLocaleTimeString():date
}
export function getDateforSelect(options){
let currentDate= new Date()
const monthList=[0,1,2,3,4,5,6,7,8,9,10,11]
let currYear=currentDate.getFullYear()
let currMonth=currentDate.getMonth()
let currDate=currentDate.getDate()
// let options='lastDay'
// console.log("currDate",currDate)
switch(options){
  case 'lastDay': {
    let lastDay;
    lastDay=new Date(currYear,currMonth,currDate-0)
    return lastDay.toISOString().substring(0,10)
    break;
}
case 'lastWeek': {
  let lastDay;
  lastDay=new Date(currYear,currMonth,currDate-5)
  return lastDay.toISOString().substring(0,10)
  break;
}
case 'lastMonth': {
  let lastDay;
  lastDay=new Date(currYear,currMonth-1,currDate+2)
  return lastDay.toISOString().substring(0,10)
  break;
}
case 'lastQuarter': {
  let lastDay;
  lastDay=new Date(currYear,currMonth-3,currDate+2)
  return lastDay.toISOString().substring(0,10)
  break;
}
  // return currMonth 'lastQuarter'
}
}


// common time ago function
export function getTimeAgo(date){
  TimeAgo.addLocale(en)
  const timeAgo = new TimeAgo('en-US')
    return timeAgo.format(new Date(date))
}

// Browser detection datas
function getPosition() {
  // Simple wrapper
  return new Promise((res, rej) => {
      navigator.geolocation.getCurrentPosition(res, rej);
  });
}
async function getLocation() {
  var position=await getPosition()
return position
}
navigator.browserNameAndVersion= (function(){
  // browser
  var ua= navigator.userAgent, tem, 
  M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if(/trident/i.test(M[1])){
      tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE '+(tem[1] || '');
  }
  if(M[1]=== 'Chrome'){
      tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
      if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
  }
  M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
  if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
  return M.join(' ');
})();
navigator.osName=(function(){
  var ua = navigator.userAgent;
  var nVer = navigator.appVersion;
  var os = '';
  var clientStrings = [
      {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
      {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
      {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
      {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
      {s:'Windows Vista', r:/Windows NT 6.0/},
      {s:'Windows Server 2003', r:/Windows NT 5.2/},
      {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
      {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
      {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
      {s:'Windows 98', r:/(Windows 98|Win98)/},
      {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
      {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
      {s:'Windows CE', r:/Windows CE/},
      {s:'Windows 3.11', r:/Win16/},
      {s:'Android', r:/Android/},
      {s:'Open BSD', r:/OpenBSD/},
      {s:'Sun OS', r:/SunOS/},
      {s:'Chrome OS', r:/CrOS/},
      {s:'Linux', r:/(Linux|X11(?!.*CrOS))/},
      {s:'iOS', r:/(iPhone|iPad|iPod)/},
      {s:'Mac OS X', r:/Mac OS X/},
      {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
      {s:'QNX', r:/QNX/},
      {s:'UNIX', r:/UNIX/},
      {s:'BeOS', r:/BeOS/},
      {s:'OS/2', r:/OS\/2/},
      {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
  ];
  for (var id in clientStrings) {
      var cs = clientStrings[id];
      if (cs.r.test(ua)) {
          os = cs.s;
          break;
      }
  }

  var osVersion = '';

  if (/Windows/.test(os)) {
      osVersion = /Windows (.*)/.exec(os)[1];
      os = 'Windows';
  }

  switch (os) {
      case 'Mac OS X':
          osVersion = /Mac OS X (10[\.\_\d]+)/.exec(ua)[1];
          break;

      case 'Android':
          osVersion = /Android ([\.\_\d]+)/.exec(ua)[1];
          break;

      case 'iOS':
          osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
          osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
          break;
  }
  return {osName:os,osVersion:osVersion}
})()

export function userAgentDetection(){
  let userAgentData={
    ua__appCodeName:navigator.appCodeName,
    ua__appName:navigator.appName,
    ua__appVersion:navigator.appVersion,
    ua__browserNameAndVersion:navigator.browserNameAndVersion,
    ua__cookieEnabled:navigator.cookieEnabled,
    ua__doNotTrack:navigator.doNotTrack,
    ua__geolocation:getLocation(),
    ua__getBattery:navigator.getBattery,
    ua__getGamepads:navigator.getGamepads,
    ua__getStorageUpdates:navigator.getStorageUpdates,
    ua__hardwareConcurrency:navigator.hardwareConcurrency,
    ua__javaEnabled:navigator.javaEnabled,
    ua__language:navigator.language,
    ua__languages:navigator.languages,
    ua__mediaDevices:navigator.mediaDevices,
    ua__maxTouchPoints:navigator.maxTouchPoints,
    ua__mimeTypes:navigator.mimeTypes,
    ua__onLine:navigator.onLine,
    ua__permissions:navigator.permissions,
    ua__platform:navigator.platform,
    ua__plugins:navigator.plugins,
    ua__product:navigator.product,
    ua__productSub:navigator.productSub,
    ua__registerProtocolHandler:navigator.registerProtocolHandler,
    ua__requestMediaKeySystemAccess:navigator.requestMediaKeySystemAccess,
    ua__requestMIDIAccess:navigator.requestMIDIAccess,
    ua__sendBeacon:navigator.sendBeacon,
    ua__serviceWorker:navigator.serviceWorker,
    ua__unregisterProtocolHandler:navigator.unregisterProtocolHandler,
    ua__userAgent:navigator.userAgent,
    ua__vendor:navigator.vendor,
    ua__vendorSub:navigator.vendorSub,
    ua__vibrate:navigator.vibrate,
    ua__webkitGetUserMedia:navigator.webkitGetUserMedia,
    ua__webkitPersistentStorage:navigator.webkitPersistentStorage,
    ua__webkitTemporaryStorage:navigator.webkitTemporaryStorage,
    ua__summary:{osDetail:navigator.osName,browserDetail:navigator.browserNameAndVersion}
  }
  return userAgentData
}

export function convertDataURIToBinary(dataURI) {
  // console.log('dataURI',dataURI)
  // var BASE64_MARKER = ';base64,';
  // var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  // var base64 = dataURI.substring(base64Index);
  // var raw = window.atob(base64);
  // var rawLength = raw.length;
  // var array = new Uint8Array(new ArrayBuffer(rawLength));
  // for(let i = 0; i < rawLength; i++) {
  //   array[i] = raw.charCodeAt(i);
  // }
  // return array;
}
//convert CSV FILE to json start 
export function CSVToArray(strData, strDelimiter) {
  // Check to see if the delimiter is defined. If not,
  // then default to comma.
  strDelimiter = (strDelimiter || ",");
  // Create a regular expression to parse the CSV values.
  var objPattern = new RegExp((
  // Delimiters.
  "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
  // Quoted fields.
  "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
  // Standard fields.
  "([^\"\\" + strDelimiter + "\\r\\n]*))"), "gi");
  // Create an array to hold our data. Give the array
  // a default empty first row.
  var arrData = [[]];
  // Create an array to hold our individual pattern
  // matching groups.
  var arrMatches = null;
  // Keep looping over the regular expression matches
  // until we can no longer find a match.
  while (arrMatches = objPattern.exec(strData)) {
      // Get the delimiter that was found.
      var strMatchedDelimiter = arrMatches[1];
      // Check to see if the given delimiter has a length
      // (is not the start of string) and if it matches
      // field delimiter. If id does not, then we know
      // that this delimiter is a row delimiter.
      if (strMatchedDelimiter.length && (strMatchedDelimiter != strDelimiter)) {
          // Since we have reached a new row of data,
          // add an empty row to our data array.
          arrData.push([]);
      }
      // Now that we have our delimiter out of the way,
      // let's check to see which kind of value we
      // captured (quoted or unquoted).
      if (arrMatches[2]) {
          // We found a quoted value. When we capture
          // this value, unescape any double quotes.
          var strMatchedValue = arrMatches[2].replace(
          new RegExp("\"\"", "g"), "\"");
      } else {
          // We found a non-quoted value.
          var strMatchedValue = arrMatches[3];
      }
      // Now that we have our value string, let's add
      // it to the data array.
      arrData[arrData.length - 1].push(strMatchedValue);
  }
  // Return the parsed data.
  return (arrData);
}

export function CSVToJSON(csv) {
  var array = CSVToArray(csv);
  var objArray = [];
  for (var i = 1; i < array.length; i++) {
      objArray[i - 1] = {};
      for (var k = 0; k < array[0].length && k < array[i].length; k++) {
          var key = array[0][k];
          objArray[i - 1][key] = array[i][k]
      }
  }

  var json = JSON.stringify(objArray);
  var str = json.replace(/},/g, "},\r\n");

  return str;
}
//end